import React from 'react';
import { Col, Divider, Row, Typography } from 'antd';
import {
  BookOutlined, BuildOutlined, CloudOutlined, EnvironmentOutlined,
  GlobalOutlined, HeartOutlined, HomeOutlined, LinkOutlined,
  RiseOutlined, SwapOutlined, TeamOutlined,
} from '@ant-design/icons';
import '../../../Styles/ResearchLabs.css';

const { Paragraph, Title } = Typography;

const researchDomains = [
  ['Domain 1 – Capacity Building in Small Satellite Technology', 'The CubeSat standard has enabled classroom satellite projects in which students can plan, design, and launch a complete satellite during their studies. SSTRL develops CubeSat training equipment for universities across Pakistan and trains students to build national capacity in small-satellite technology.'],
  ['Domain 2 – Joint Mission to Plan, Design and Develop a 3U CubeSat', 'SSTRL will plan, design, and develop a 3U CubeSat with universities across Pakistan. Undergraduate and postgraduate students will participate in mission planning, design, testing, and commissioning, with a national contest used to identify novel mission ideas.'],
  ['Domain 3 – Remote Access to the IST Ground Station', 'IST operates a VHF, UHF, and S-band ground station for amateur-class satellites. SSTRL will enable remote access so students throughout Pakistan can communicate with satellites and download free data from pico- and nano-satellite missions for experimentation.'],
];

const focusedSdgs = [
  ['Good Health and Wellbeing', HeartOutlined], ['Quality Education', BookOutlined],
  ['Gender Equality', TeamOutlined], ['Decent Work and Economic Growth', RiseOutlined],
  ['Reduced Inequality', SwapOutlined], ['Industry, Innovation and Infrastructure', BuildOutlined],
  ['Sustainable Cities and Communities', HomeOutlined], ['Climate Action', CloudOutlined],
  ['Life Below Water', GlobalOutlined], ['Life On Land', EnvironmentOutlined],
  ['Partnerships to achieve the Goal', LinkOutlined],
];

const SstrlDomain = () => (
  <section className="research-domains-section sdssl-research-domains-section">
    <div className="research-domains-inner">
      <Row gutter={[72, 44]} justify="space-between">
        <Col xs={24} lg={15}>
          <Title level={2} className="research-domains-title">Research Domains</Title>
          <Divider className="ncgsa-divider" />
          {researchDomains.map(([title, description]) => (
            <article className="research-domain" key={title}>
              <Title level={4} className="research-domain-title">{title}</Title>
              <Paragraph className="research-domain-copy">{description}</Paragraph>
            </article>
          ))}
        </Col>
        <Col xs={24} lg={8}>
          <Title level={2} className="research-domains-title">Focused SDGs</Title>
          <Divider className="ncgsa-divider" />
          <ul className="sdg-focus-list">
            {focusedSdgs.map(([label, Icon]) => (
              <li key={label}>
                <span className="sdg-focus-icon" aria-hidden="true"><Icon /></span>
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
    </div>
  </section>
);

export default SstrlDomain;
